// Mock data for Oncology medicines

export const oncologyHeroData = {
  title: "Oncology Medicines",
  subtitle: "Affordable Cancer Treatment Medications from India",
  description: "Access authentic, licensed oncology medications at up to 70% lower costs. Direct sourcing from India's leading pharmaceutical manufacturers with express delivery to 30+ countries.",
  stats: [
    { number: "50+", label: "Oncology Products" },
    { number: "70%", label: "Average Savings" },
    { number: "100%", label: "Authentic & Licensed" },
    { number: "10-14", label: "Days Delivery" }
  ]
};

export const oncologyProducts = [
  {
    id: "imat-400",
    name: "Imatinib 400mg",
    genericName: "Imatinib Mesylate",
    category: "Targeted Therapy",
    indication: "Chronic Myeloid Leukemia (CML)",
    price: "$540",
    originalPrice: "$8,500",
    savings: "93%",
    description: "High-quality generic Imatinib 400mg for Chronic Myeloid Leukemia (CML). WHO-GMP certified, sourced from licensed Indian manufacturers.",
    dosage: "As prescribed by physician. Typically once or twice daily.",
    packaging: "30 tablets/capsules per pack",
    manufacturer: "Cipla",
    storage: "Store below 25°C in a cool, dry place. Keep away from direct sunlight.",
    sideEffects: "Common side effects may include nausea, headache, fatigue. Consult your doctor if symptoms persist."
  },
  {
    id: "gefit-250",
    name: "Gefitinib 250mg",
    genericName: "Iressa",
    category: "Targeted Therapy",
    indication: "Non-Small Cell Lung Cancer",
    price: "$180",
    originalPrice: "$1,800",
    savings: "90%",
    description: "Generic Gefitinib 250mg used for target therapy in specific lung cancer cases. Sourced from high-trust manufacturers like Natco.",
    dosage: "One tablet daily or as directed by an oncologist.",
    packaging: "30 tablets per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature (15-30°C).",
    sideEffects: "Diarrhea, skin rash, itching, dry skin."
  },
  {
    id: "soraf-200",
    name: "Sorafenib 200mg",
    genericName: "Nexavar / Soranib",
    category: "Targeted Therapy",
    indication: "Advanced Liver & Kidney Cancer",
    price: "$620",
    originalPrice: "$9,200",
    savings: "93%",
    description: "Advanced multi-kinase inhibitor. Used in renal cell carcinoma and hepatocellular carcinoma.",
    dosage: "400mg (2 tablets of 200mg) twice daily.",
    packaging: "120 tablets per pack",
    manufacturer: "Cipla / Natco",
    storage: "Store at 25°C; excursions permitted to 15-30°C.",
    sideEffects: "Fatigue, weight loss, rash, hand-foot skin reaction."
  },
  {
    id: "erlot-150",
    name: "Erlotinib 150mg",
    genericName: "Tarceva",
    category: "Targeted Therapy",
    indication: "Lung & Pancreatic Cancer",
    price: "$480",
    originalPrice: "$2,800",
    savings: "83%",
    description: "Highly effective EGFR inhibitor for non-small cell lung cancer.",
    dosage: "150mg daily on an empty stomach.",
    packaging: "30 tablets per pack",
    manufacturer: "Natco / Cipla",
    storage: "Store at room temperature.",
    sideEffects: "Rash, diarrhea, loss of appetite."
  },
  {
    id: "sunit-50",
    name: "Sunitinib 50mg",
    genericName: "Sutent / Sunitix",
    category: "Targeted Therapy",
    indication: "Kidney & GIST Cancer",
    price: "$720",
    originalPrice: "$10,500",
    savings: "93%",
    description: "Multi-targeted receptor tyrosine kinase inhibitor.",
    dosage: "50mg orally once daily for 4 weeks on, 2 weeks off.",
    packaging: "28 capsules per pack",
    manufacturer: "Pfizer / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Fatigue, diarrhea, nausea, hypertension."
  },
  {
    id: "lenal-25",
    name: "Lenalidomide 25mg",
    genericName: "Revlimid / Lenangio",
    category: "Immunomodulator",
    indication: "Multiple Myeloma",
    price: "$1,100",
    originalPrice: "$18,000",
    savings: "94%",
    description: "Potent immunomodulatory drug for multiple myeloma patients.",
    dosage: "25mg daily for 21 days of repeated 28-day cycles.",
    packaging: "21 capsules per pack",
    manufacturer: "Natco",
    storage: "Store at controlled room temperature.",
    sideEffects: "Diarrhea, itching, rash, tiredness."
  },
  {
    id: "dasat-100",
    name: "Dasatinib 100mg",
    genericName: "Sprycel",
    category: "Targeted Therapy",
    indication: "Ph+ Myeloid Leukemia (CML)",
    price: "$880",
    originalPrice: "$12,500",
    savings: "93%",
    description: "Second-generation tyrosine kinase inhibitor for CML.",
    dosage: "100mg once daily.",
    packaging: "60 tablets per pack",
    manufacturer: "Cipla / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Headache, shortness of breath, fatigue."
  },
  {
    id: "nilot-200",
    name: "Nilotinib 200mg",
    genericName: "Tasigna",
    category: "Targeted Therapy",
    indication: "Chronic Myeloid Leukemia",
    price: "$680",
    originalPrice: "$13,500",
    savings: "95%",
    description: "TKI used for newly diagnosed Ph+ CML in chronic phase.",
    dosage: "300mg to 400mg twice daily.",
    packaging: "112 capsules per pack",
    manufacturer: "Novartis / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Nausea, rash, headache, itching."
  },
  {
    id: "temoz-250",
    name: "Temozolomide 250mg",
    genericName: "Temodar / Temonat",
    category: "Chemotherapy",
    indication: "Brain Tumors / Glioblastoma",
    price: "$380",
    originalPrice: "$5,500",
    savings: "93%",
    description: "Oral alkylating agent used for glioblastoma multiforme.",
    dosage: "Dosage varies by body surface area and cycle phase.",
    packaging: "5 capsules per pack",
    manufacturer: "Natco / Sun Pharma",
    storage: "Store at 25°C; protect from moisture.",
    sideEffects: "Nausea, vomiting, headache, fatigue."
  },
  {
    id: "capec-500",
    name: "Capecitabine 500mg",
    genericName: "Xeloda",
    category: "Chemotherapy",
    indication: "Breast & Colorectal Cancer",
    price: "$180",
    originalPrice: "$1,800",
    savings: "90%",
    description: "Fluoropyrimidine carbamate used as a prodrug of 5-fluorouracil.",
    dosage: "Varies based on weight, usually twice daily for 2 weeks.",
    packaging: "120 tablets per pack",
    manufacturer: "Cipla / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, nausea, vomiting, hand-foot syndrome."
  },
  {
    id: "bortez-3-5",
    name: "Bortezomib 3.5mg",
    genericName: "Velcade / Bortenat",
    category: "Targeted Therapy",
    indication: "Multiple Myeloma",
    price: "$150",
    originalPrice: "$2,800",
    savings: "95%",
    description: "Proteasome inhibitor for multiple myeloma and mantle cell lymphoma.",
    dosage: "Administered as an injection by a healthcare professional.",
    packaging: "Single dose vial",
    manufacturer: "Natco / Dr. Reddy's",
    storage: "Store at controlled room temperature; avoid light.",
    sideEffects: "Nausea, diarrhea, fatigue, peripheral neuropathy."
  },
  {
    id: "pazop-400",
    name: "Pazopanib 400mg",
    genericName: "Votrient",
    category: "Targeted Therapy",
    indication: "Advanced Renal Cancer",
    price: "$580",
    originalPrice: "$8,500",
    savings: "93%",
    description: "Tyrosine kinase inhibitor for advanced renal cell carcinoma.",
    dosage: "800mg (2 tablets of 400mg) once daily.",
    packaging: "30 tablets per pack",
    manufacturer: "Natco / Biocon",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, hypertension, hair color changes."
  },
  {
    id: "lapat-250",
    name: "Lapatinib 250mg",
    genericName: "Tykerb / Tykernat",
    category: "Targeted Therapy",
    indication: "HER2+ Breast Cancer",
    price: "$250",
    originalPrice: "$3,500",
    savings: "93%",
    description: "Dual tyrosine kinase inhibitor for HER2-positive breast cancer.",
    dosage: "1,250mg (5 tablets) daily or as directed.",
    packaging: "150 tablets per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, rash, nausea, hand-foot syndrome."
  },
  {
    id: "everol-10",
    name: "Everolimus 10mg",
    genericName: "Afinitor / Evermil",
    category: "Targeted Therapy",
    indication: "Advanced Kidney & Breast Cancer",
    price: "$780",
    originalPrice: "$12,800",
    savings: "94%",
    description: "mTOR inhibitor for advanced renal cell carcinoma and breast cancer.",
    dosage: "10mg once daily.",
    packaging: "30 tablets per pack",
    manufacturer: "Natco / Cipla",
    storage: "Store at room temperature; protect from light.",
    sideEffects: "Mouth sores, infections, rash, fatigue."
  },
  {
    id: "crizot-250",
    name: "Crizotinib 250mg",
    genericName: "Xalkori",
    category: "Targeted Therapy",
    indication: "ALK+ Non-Small Cell Lung Cancer",
    price: "$850",
    originalPrice: "$15,000",
    savings: "94%",
    description: "ALK and ROS1 inhibitor for advanced lung cancer.",
    dosage: "250mg twice daily.",
    packaging: "60 capsules per pack",
    manufacturer: "Cipla / Biocon",
    storage: "Store at room temperature.",
    sideEffects: "Vision changes, nausea, diarrhea, vomiting."
  },
  {
    id: "veneto-100",
    name: "Venetoclax 100mg",
    genericName: "Venclexta",
    category: "Targeted Therapy",
    indication: "CLL / AML Leukemia",
    price: "$640",
    originalPrice: "$8,800",
    savings: "93%",
    description: "BCL-2 inhibitor that helps restore natural cell death in cancer cells.",
    dosage: "Gradual dose escalation up to 400mg daily.",
    packaging: "112 tablets/month pack",
    manufacturer: "Abbvie / Generic",
    storage: "Store at room temperature.",
    sideEffects: "Neutropenia, diarrhea, nausea, upper respiratory tract infection."
  },
  {
    id: "regor-40",
    name: "Regorafenib 40mg",
    genericName: "Stivarga / Resihance",
    category: "Targeted Therapy",
    indication: "Colorectal Cancer",
    price: "$740",
    originalPrice: "$10,500",
    savings: "93%",
    description: "Multi-kinase inhibitor for metastatic colorectal cancer.",
    dosage: "160mg (4 tablets) daily for first 21 days of cycle.",
    packaging: "28 tablets per bottle",
    manufacturer: "Bayer / Natco",
    storage: "Store in original bottle; discard after 7 weeks.",
    sideEffects: "Fatigue, hand-foot skin reaction, diarrhea."
  },
  {
    id: "ibrut-140",
    name: "Ibrutinib 140mg",
    genericName: "Imbruvica",
    category: "Targeted Therapy",
    indication: "CLL / Mantle Cell Lymphoma",
    price: "$940",
    originalPrice: "$12,800",
    savings: "93%",
    description: "Bruton's tyrosine kinase (BTK) inhibitor for B-cell malignancies.",
    dosage: "420mg to 560mg daily depending on condition.",
    packaging: "90 capsules per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, tiredness, muscle pain, bruising."
  },
  {
    id: "cerit-450",
    name: "Ceritinib 450mg",
    genericName: "Zykadia",
    category: "Targeted Therapy",
    indication: "ALK+ Lung Cancer",
    price: "$1,050",
    originalPrice: "$16,500",
    savings: "94%",
    description: "Second-generation ALK inhibitor for non-small cell lung cancer.",
    dosage: "450mg orally once daily with food.",
    packaging: "90 capsules per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, nausea, vomiting, fatigue."
  },
  {
    id: "palbo-125",
    name: "Palbociclib 125mg",
    genericName: "Ibrance",
    category: "Targeted Therapy",
    indication: "ER+/HER2- Breast Cancer",
    price: "$580",
    originalPrice: "$12,500",
    savings: "95%",
    description: "CDK 4/6 inhibitor for advanced or metastatic breast cancer.",
    dosage: "125mg once daily with food for 21 days, then 7 days off.",
    packaging: "21 capsules per pack",
    manufacturer: "Natco / Dr. Reddy's",
    storage: "Store at room temperature.",
    sideEffects: "Neutropenia, infections, fatigue, nausea."
  },
  {
    id: "caboz-60",
    name: "Cabozantinib 60mg",
    genericName: "Cabometyx",
    category: "Targeted Therapy",
    indication: "Thyroid & Kidney Cancer",
    price: "$920",
    originalPrice: "$14,500",
    savings: "94%",
    description: "Multi-kinase inhibitor used for renal cell carcinoma and medullary thyroid cancer.",
    dosage: "60mg daily on an empty stomach.",
    packaging: "30 tablets per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, fatigue, nausea, hypertension."
  },
  {
    id: "alect-150",
    name: "Alectinib 150mg",
    genericName: "Alecensa",
    category: "Targeted Therapy",
    indication: "ALK+ Non-Small Cell Lung Cancer",
    price: "$980",
    originalPrice: "$15,500",
    savings: "94%",
    description: "Highly selective ALK inhibitor for advanced lung cancer.",
    dosage: "600mg twice daily with food.",
    packaging: "224 capsules per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Constipation, fatigue, swelling of hands/feet."
  },
  {
    id: "cerit-150",
    name: "Ceritinib 150mg",
    genericName: "Tasigna",
    category: "Targeted Therapy",
    indication: "Ph+ Chronic Myeloid Leukemia",
    price: "$280",
    originalPrice: "$8,500",
    savings: "97%",
    description: "Kinase inhibitor for chronic myeloid leukemia chronic phase.",
    dosage: "300mg to 400mg twice daily.",
    packaging: "112 capsules per pack",
    manufacturer: "Novartis / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Headache, nausea, rash, itching."
  },
  {
    id: "afatin-40",
    name: "Afatinib 40mg",
    genericName: "Gilotrif / Afanat",
    category: "Targeted Therapy",
    indication: "NSCLC Lung Cancer",
    price: "$480",
    originalPrice: "$8,800",
    savings: "95%",
    description: "Tyrosine kinase inhibitor for specific EGFR mutation lung cancer.",
    dosage: "40mg daily or as prescribed.",
    packaging: "30 tablets per pack",
    manufacturer: "Cipla / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, rash, mouth sores."
  },
  {
    id: "enorm-2",
    name: "Enzolutamide 20mg",
    genericName: "Xtandi / Enzamide",
    category: "Hormone Therapy",
    indication: "Prostate Cancer",
    price: "$380",
    originalPrice: "$14,000",
    savings: "97%",
    description: "Androgen receptor inhibitor for metastatic prostate cancer.",
    dosage: "160mg (4 capsules) once daily.",
    packaging: "112 capsules per pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Fatigue, hot flashes, joint pain."
  },
  {
    id: "osimer-80",
    name: "Osimertinib 80mg",
    genericName: "Tagrisso",
    category: "Targeted Therapy",
    indication: "EGFR+ Lung Cancer",
    price: "$620",
    originalPrice: "$8,800",
    savings: "93%",
    description: "Effective third-generation EGFR inhibitor for lung cancer.",
    dosage: "80mg daily with or without food.",
    packaging: "30 tablets per pack",
    manufacturer: "Cipla / Natco",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, rash, dry skin, nail changes."
  },
  {
    id: "ruxol-20",
    name: "Ruxolitinib 20mg",
    genericName: "Jakavi",
    category: "Targeted Therapy",
    indication: "Myelofibrosis",
    price: "$720",
    originalPrice: "$11,500",
    savings: "94%",
    description: "JAK1/JAK2 inhibitor for myelofibrosis and polycythemia vera.",
    dosage: "Varies; usually 5mg to 20mg twice daily.",
    packaging: "60 tablets per bottle",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Anemia, tiredness, dizziness, headache."
  },
  {
    id: "idela-150",
    name: "Idelalisib 150mg",
    genericName: "Zydelig",
    category: "Targeted Therapy",
    indication: "CLL / Follicular Lymphoma",
    price: "$980",
    originalPrice: "$8,800",
    savings: "89%",
    description: "PI3K delta inhibitor for relapsed B-cell malignancies.",
    dosage: "150mg twice daily.",
    packaging: "60 tablets per pack",
    manufacturer: "Gilead / Generic",
    storage: "Store at room temperature.",
    sideEffects: "Diarrhea, fever, fatigue, nausea."
  },
  {
    id: "veneto-100-2",
    name: "Venetoclax 100mg",
    genericName: "Venclexta",
    category: "Targeted Therapy",
    indication: "Leukemia (CLL / AML)",
    price: "$720",
    originalPrice: "$12,800",
    savings: "94%",
    description: "Selective BCL-2 inhibitor used across various leukemia stages.",
    dosage: "Follow oncologist's ramp-up schedule.",
    packaging: "112 tablets/month pack",
    manufacturer: "Natco",
    storage: "Store at room temperature.",
    sideEffects: "Upper respiratory tract infection, fatigue, diarrhea."
  },
  {
    id: "pomali-4",
    name: "Pomalidomide 4mg",
    genericName: "Pomalyst / Pomalid",
    category: "Immunomodulator",
    indication: "Multiple Myeloma",
    price: "$1,200",
    originalPrice: "$15,500",
    savings: "92%",
    description: "Potent immunomodulatory drug for relapsed/refractory myeloma.",
    dosage: "4mg once daily for 21 days of 28-day cycle.",
    packaging: "21 capsules per pack",
    manufacturer: "Natco / Cipla",
    storage: "Store at room temperature.",
    sideEffects: "Tiredness, diarrhea, shortness of breath."
  }
];


export const oncologyCategories = [
  "All Categories",
  "Targeted Therapy",
  "Hormone Therapy",
  "Chemotherapy",
  "Immunotherapy",
  "Monoclonal Antibody",
  "Immunomodulator",
  "Supportive Care"
];

export const oncologyTrustBadges = [
  {
    title: "100% Authentic",
    description: "All medications sourced directly from licensed Indian manufacturers",
    icon: "ShieldCheck"
  },
  {
    title: "Expert Support",
    description: "Oncology specialists available to guide you through the process",
    icon: "Users"
  },
  {
    title: "Secure Delivery",
    description: "Temperature-controlled express air shipping with real-time tracking",
    icon: "Plane"
  },
  {
    title: "Licensed & Certified",
    description: "45 years of pharmaceutical expertise with all necessary certifications",
    icon: "Award"
  }
];

export const oncologyFAQs = [
  {
    question: "Are these oncology medications authentic?",
    answer: "Yes, all our oncology medications are 100% authentic and sourced directly from licensed Indian pharmaceutical manufacturers like Cipla, Natco, Dr. Reddy's, and Biocon. Each product comes with proper documentation and batch numbers for full traceability."
  },
  {
    question: "How much can I save on cancer medications?",
    answer: "On average, customers save 70-75% on oncology medications compared to prices in the US, UK, and other countries. The exact savings vary by medication, but our generic versions maintain the same quality and efficacy as branded versions."
  },
  {
    question: "Do I need a prescription?",
    answer: "Yes, we require a valid prescription for all oncology medications. You can upload your prescription when submitting an inquiry, or send it to our team via WhatsApp. Our experts will verify the prescription before processing your order."
  },
  {
    question: "How long does delivery take?",
    answer: "Express air shipping typically takes 10-14 days to reach most countries. We provide real-time tracking and ensure temperature-controlled packaging for sensitive medications. Expedited shipping options are available for urgent requirements."
  },
  {
    question: "Can I consult with an oncology specialist?",
    answer: "Yes, our team includes experienced pharmaceutical consultants who specialize in oncology medications. They can help you understand treatment options, dosing, and potential alternatives. Connect with us via WhatsApp or phone for personalized assistance."
  },
  {
    question: "What if my medication is not listed?",
    answer: "We have access to 5000+ medications beyond what's listed on our website. If you don't see your specific oncology medication, please contact us with the medication name and dosage. Our team will source it for you from verified manufacturers across India."
  },
  {
    question: "Is cross-border medication delivery legal?",
    answer: "Yes, we operate in full compliance with international pharmaceutical regulations. We handle all necessary documentation, customs clearance, and ensure proper licensing. Our 45 years of experience ensures smooth, legal delivery to 30+ countries."
  },
  {
    question: "How do I pay for my order?",
    answer: "We accept multiple payment methods including wire transfer, credit/debit cards, and online payment gateways. Payment details will be provided after our team reviews your inquiry and provides a quotation. All transactions are secure and encrypted."
  }
];

export const oncologyTestimonials = [
  {
    name: "John D.",
    country: "United States",
    cancer: "Lung Cancer",
    medication: "Gefitinib",
    rating: 5,
    text: "MediSeller helped me save over $15,000 on my lung cancer treatment. The Gefitinib I received was authentic and came with all proper documentation. Their team was incredibly supportive throughout the process.",
    savings: "$15,000+"
  },
  {
    name: "Margaret S.",
    country: "United Kingdom",
    cancer: "Breast Cancer",
    medication: "Letrozole + Palbociclib",
    rating: 5,
    text: "As a breast cancer patient, the cost of treatment was overwhelming. MediSeller's affordable medications and expert guidance made my treatment accessible. The quality is excellent and delivery was faster than expected.",
    savings: "$8,500+"
  },
  {
    name: "David M.",
    country: "Canada",
    cancer: "Kidney Cancer",
    medication: "Pazopanib",
    rating: 5,
    text: "I've been ordering Pazopanib from MediSeller for over a year. The consistency in quality and their professional service has been remarkable. They truly care about cancer patients and their wellbeing.",
    savings: "$24,000+"
  },
  {
    name: "Patricia L.",
    country: "Australia",
    cancer: "Multiple Myeloma",
    medication: "Lenalidomide",
    rating: 5,
    text: "Lenalidomide was financially impossible until I found MediSeller. They made it affordable and ensured proper cold-chain shipping. Their oncology consultant answered all my questions patiently.",
    savings: "$36,000+"
  }
];

export const oncologySectionContent = {
  midPageCTA: {
    title: "Can't Find Your Medication?",
    description: "We have access to 5000+ generic medications. Our specialists can help you source any medication from verified Indian manufacturers at up to 80% savings.",
    whatsappText: "Chat on WhatsApp",
    requestText: "Submit Custom Request"
  },
  testimonials: {
    title: "Patient Success Stories",
    description: "Hear from patients worldwide who saved thousands on their oncology medications"
  },
  faqs: {
    title: "Frequently Asked Questions",
    description: "Everything you need to know about ordering oncology medications"
  },
  finalCTA: {
    title: "Ready to Save on Your Treatment?",
    description: "Get expert consultation and authentic oncology medications delivered directly to your doorstep.",
    whatsappText: "Start WhatsApp Chat",
    requestText: "Request Free Consultation"
  }
};
